import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { FadeIn } from "@/components/FadeIn";
import { RevealHeading } from "@/components/RevealHeading";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen flex items-center justify-center pt-20">
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <div className="container-custom text-center">
        <RevealHeading
          tag="h1"
          lines={["404"]}
          className="font-display font-black text-6xl sm:text-8xl tracking-tight text-white"
        />
        <FadeIn delay={0.3}>
          <p className="mt-6 text-zinc-500">This page doesn't exist or has been moved.</p>
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="mt-10 inline-flex items-center gap-2 bg-white text-black font-bold text-xs tracking-widest uppercase px-8 py-4 hover:bg-violet-500 hover:text-white transition-colors duration-300"
          >
            Back To Home
          </Link>
        </FadeIn>
      </div>
    </div>
  );
}
